module.exports = __webpack_public_path__ + "img/5_Cell_cover.d1c2226e.jpg";